import { app } from '../app/app.js';
import { navigation } from '../app/navigation.js';
import { AccountPanelBase } from './account_panel_base.js';

/**
 * Cancel password recovery panel.
 */
class CancelPwdRecoveryPanel extends AccountPanelBase {
  static id = navigation.kCancelPwdRecoveryPanelId;

  static markup = `
    <div class='spacer'></div>
    <div class='msg' hidden></div>
    <div class='spacer-3'></div>
  `;

  get historyState() {
    return [
      { page: this.page },
      `CamperAid - Cancel password recovery`,
      `${window.location.origin}/cancel-pwd-recovery`,
    ];
  }

  switchOn() {
    super.switchOn();
    return this.cancelRecovery();
  }

  async cancelRecovery() {
    let hash = navigation.params.pwdRecoveryHash;
    if (!hash) {
      this.msgBox.error(`
        No valid password recovery request is found. It could be cancelled already.
      `);
      return;
    }

    this.msgBox.hide();

    let result = await app.cancelPasswordRecovery(hash);
    if (result == app.Success) {
      this.msgBox.success(`
        Password recovery was cancelled. Click
        <a href='/intro'>here</a> for homepage.
      `);
      return;
    }
    this.msgBox.unexpectedError();
  }
}

navigation.registerPanel(CancelPwdRecoveryPanel);

export { CancelPwdRecoveryPanel };
